<template>
    <div class="subject-type" v-loading="loading">
        <grade-index
            v-if="playerDetail.paperCode"
            :playerDetail="playerDetail"
        ></grade-index>
    </div>
</template>
<script>
import gradeIndex from "@/examinationViews/examList/gradeViews/gradeIndex";
import Api from '@/api/fetch'
import { Base64 } from 'js-base64'
export default {
    name: 'subjectType',
    data(){
        return{
            activeName: this.$t('showLxRecord.SC'),
            internalTypeComp: {
                '单选': 'Single',
                '多选题': 'More',
                '判断': 'Judge',
                '实操': 'Operation',
                '组合': 'combination',
                '审计附件题': 'Single'
            },
            taskData: {
                isMy: false
            },
            playerDetail:{},
            loading: false
        }
    },
    components:{
        gradeIndex
        // Single, More, Judge, Operation, combination, myComponent
    },
    props: {
        paperData: Object,
        planData: Object
    },
    watch:{
        paperData(){
            this.activeName = Object.keys(this.paperData)[0]
            if(Object.keys(this.paperData).indexOf(this.$t('showLxRecord.SC')) != -1){
                this.getPlayerInfo()
            }
        },
        planData: {
            deep: true,
            handler(){
                this.getPlayerInfo()
            }
        }
    },
    created(){
        this.getPlayerInfo()
    },
    methods:{
        answerShow(key,index) {
            this.$parent.answerShow(key,index)
        },
        getPlayerInfo(){
            this.loading = true
            let { planId, pattern_lx } = JSON.parse(Base64.decode(this.$route.query.q))
            let { mainVersion, subVersion } = this.planData.practiseLog || {}
            if(!mainVersion || !subVersion){
                return false
            }
            Api.playerDetailScore({
                planId,
                mainVersion,
                pattern: pattern_lx,
                subVersion,
                orgId: pattern_lx == 0 ? this.planData.teamDto.orgId : this.planData.playerDto.orgId,
                userId: pattern_lx == 0 ? undefined : this.planData.playerDto.userId,
                teamId: pattern_lx == 0 ? this.planData.teamDto.teamId : undefined,
            }).then(res=>{
                if(res.code == 0){
                    let playerInfo = res.data
                    playerInfo.matchPlanId = planId
                    playerInfo.matchPattern = pattern_lx
                    this.playerDetail = playerInfo
                    console.log(playerInfo)
                    this.loading = false
                }else {
                    this.$notify({ title: this.$t('showLxRecord.CZ'), message: res.msg || this.$t('showLxRecord.HQXSXQSB'), type: 'error' });
                }
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.subject-type{
    // flex: 1;
    width: 50%;
    height: calc(100vh - 193px);
}
/deep/ .el-tabs__item{
    width: 120px;
    text-align: center;
}
/deep/ .el-tab-pane {
    // height: calc(100vh - 250px);
    overflow-y: auto;
}
/deep/ .el-divider {
    background-color: #5397F7;
}
.title-box{
    font-weight: bold;
}
.jx-box{
    width: 100%;
    overflow: hidden;
}
</style>